require("client/style/swiftref_box.css");
require("client/static/box.svg");
